module.exports = __webpack_public_path__ + "static/images/62cb352ec053a9d5da87e7304ec094cc.webp";